// Type-only import: keeps this pure helper (and its unit test) free of the
// @utils barrel and of the native geolocation module.
import type { Coords } from '../../../utils/geolocation'

/** The part of my profile the map needs to place me. */
export interface SavedPosition {
  latitude?: number | null
  longitude?: number | null
}

/**
 * Where to draw "me" on the map:
 * - the live position from the browser / phone when it gave one,
 * - otherwise the last position saved on my profile (so I still show up when
 *   location is refused or still pending),
 * - otherwise nowhere (`null`).
 */
export function resolveMyMapPosition(
  livePosition: Coords | null | undefined,
  profile: SavedPosition | null | undefined,
): Coords | null {
  if (livePosition) return livePosition
  if (profile?.latitude != null && profile?.longitude != null) {
    return { latitude: profile.latitude, longitude: profile.longitude }
  }
  return null
}
